import { api } from '@api/api2';

export const getDeviceCategories = () =>
  api.no_vers('get', 'device_categories/get-device-catigories');
